<template>
	<div class="box-page">
		<div class="col-12 pl-0 pr-0">
			<div class="col-12 pl-0 pr-0 d-flex flex-wrap">
				<div class="col-12 col-lg-12 px-0">
					<div class="col-12 px-2 py-3 p-md-3 d-flex flex-wrap rounded-cus cus-box-shadow bg-white">
						<div class="col-2 col-md-1 my-auto">
							<div class="font-size-12 font-size-sm-10">
								<router-link class="text-deco" to="/receipt">
									<i class="fas fa-arrow-left color-light-black"></i>
								</router-link>
							</div>
						</div>
						<div class="col-10 col-md-11 pl-0 d-md-flex justify-content-between" v-if="detailReceipt.sdo_code">
							<div class="font-size-14 font-size-sm-12 font-weight-bold color-blue">{{ detailReceipt.sdo_code }}</div>
							<div class="font-weight-bold">{{ detailReceipt.sdo_status_on_delivery_datetime | tanggaljam }}</div>
						</div>
						<div class="col-10 col-md-11 pl-0" v-else>
							<vcl :width='300' :height='10'>
								<rect x="0" y="0" rx="2" ry="2" width="85" height="10" />
								<rect x="245" y="0" rx="2" ry="2" width="55" height="10" />
							</vcl>
						</div>
					</div>
					<div>
						<div class="col-12 px-2 py-3 p-md-3 mt-3 rounded-cus cus-box-shadow bg-white" v-if="Object.values(detailReceipt).length == 0">
							<vcl :width='300' :height='142'>
								<rect x="5" y="3" rx="2" ry="2" width="75" height="10" />
								<rect x="5" y="20" rx="2" ry="2" width="30" height="6" />
								<rect x="45" y="20" rx="2" ry="2" width="75" height="6" />
								<rect x="5" y="30" rx="2" ry="2" width="30" height="6" />
								<rect x="45" y="30" rx="2" ry="2" width="50" height="6" />
								<rect x="5" y="40" rx="2" ry="2" width="30" height="6" />
								<rect x="45" y="40" rx="2" ry="2" width="50" height="6" />
								<rect x="5" y="54" rx="2" ry="2" width="120" height="50" />
								<rect x="130" y="54" rx="2" ry="2" width="120" height="50" />
								<rect x="5" y="113" rx="2" ry="2" width="30" height="6" />
								<rect x="5" y="123" rx="2" ry="2" width="75" height="6" />
								<rect x="5" y="133" rx="2" ry="2" width="75" height="6" />
								<rect x="85" y="128" rx="2" ry="2" width="40" height="6" />
								<rect x="130" y="113" rx="2" ry="2" width="30" height="6" />
								<rect x="130" y="123" rx="2" ry="2" width="75" height="6" />
								<rect x="130" y="133" rx="2" ry="2" width="75" height="6" />
								<rect x="210" y="128" rx="2" ry="2" width="40" height="6" />
							</vcl>
						</div>
						<div class="col-12 px-2 py-3 p-md-3 mt-3 d-flex flex-wrap rounded-cus cus-box-shadow bg-white" v-else>
							<div class="col-12 pb-3 font-size-sm-12 font-size-14 text-uppercase font-weight-bold">{{ detailReceipt.warehouse_name }}</div>
							<div class="col-12 pb-4 font-size-sm-10 font-size-12">
								<div class="row">
									<div class="col-12 col-md-2 font-weight-bold">Alamat</div>
									<div class="col-12 col-md-10">{{ detailReceipt.warehouse_address }}</div>
									<div class="pt-2 col-12 col-md-2 font-weight-bold">Phone</div>
									<div class="pt-md-2 col-12 col-md-10">{{ detailReceipt.warehouse_mobilephone }}</div>
								</div>
							</div>
							<div class="col-12 pb-4 font-size-sm-10 font-size-12">
								<div class="row">
									<div class="col-12 col-md-8 col-lg-6 pr-lg-2">
										<div class="col-12 py-2 rounded-cus border-dashed border-width-1 h-100">
											<div class="row">
												<div class="col-3">Nomor</div>
												<div class="col-9">
													<span>:</span>
													<span class="pl-3">{{ detailReceipt.sdo_code }}</span>
												</div>
												<div class="pt-2 col-3">Tanggal</div>
												<div class="pt-2 col-9">
													<span>:</span>
													<span class="pl-3">{{ detailReceipt.sdo_status_on_delivery_datetime | tanggaljam }}</span>
												</div>
												<div class="pt-2 col-3" v-if="false">Bayar</div>
												<div class="pt-2 col-9" v-if="false">
													<span>:</span>
													<span class="pl-3">BRI Rp 21.750.000</span>
												</div>
												<div class="pt-2 col-3">MC ID</div>
												<div class="pt-2 col-9">
													<span>:</span>
													<span class="pl-3">{{ userData.stockist_code }}</span>
												</div>
											</div>
										</div>
									</div>
									<div class="col-12 col-md-8 col-lg-6 pt-3 pt-lg-0 pl-lg-2">
										<div class="col-12 py-2 rounded-cus border-dashed border-width-1 h-100">
											<div class="row">
												<div class="col-3">Penerima</div>
												<div class="col-9 d-flex">
													<div>:</div>
													<div class="pl-3">{{ detailReceipt.customer_name }}</div>
												</div>
												<div class="pt-2 col-3">Telepon</div>
												<div class="pt-2 col-9 d-flex">
													<div>:</div>
													<div class="pl-3">{{ detailReceipt.customer_mobilephone }}</div>
												</div>
												<div class="pt-2 col-3">Alamat</div>
												<div class="pt-2 col-9 d-flex">
													<div>:</div>
													<div class="pl-3">{{ detailReceipt.customer_address }}</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 pb-2 pb-lg-4 font-size-12">
								<div class="pt-2 table-responsive">
									<table class="table table-bordered mb-0 font-size-sm-9 font-size-10">
										<thead class="bg-pos">
											<tr>
												<td>No</td>
												<td>Jenis Barang</td>
												<td>Jumlah</td>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(product, i) in detailReceipt.detail" :key="product.sdo_detail_id">
												<td>{{ i+1 }}</td>
												<td>{{ product.sdo_detail_product_name }}</td>
												<td>{{ product.sdo_detail_quantity_received }}</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div class="col-12 pb-2 font-size-12">
								<div class="row">
									<div class="col-12 col-md-8 col-lg-6 pt-3 pt-lg-0 pr-md-2 mb-4 justify-content-between" v-for="detail in detailReceipt.detail" :key="detail.sdo_detail_id">
										<div class="font-weight-bold font-size-sm-10 font-size-12">{{ detail.sdo_detail_product_name }}</div>
                      <div class="pt-2 row d-flex align-items-center" v-for="(platform, index) in sold_platform" :key="index">
                        <div class="col-6">Jumlah serial {{platform}}</div>
                        <div class="input-group color-green col-6">
                          <input v-model="detail.serialProduct[platform].quantity" type="text" class="form-control box-blue rounded-cus">
                          <div class="input-group-append">
                            <button :disabled="detail.serialProduct[platform].quantity <= 0 || !detail.serialProduct[platform].quantity" class="btn btn-blue box-purple rounded-cus" @click="listSerialChange(detail, platform)">
                              <div class="pl-2 text-uppercase font-weight-bold">Pilih Serial</div>
                            </button>
                          </div>
                        </div>
                      </div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<i-modal ref="modalAlert" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<AlertModal :message="alertMessage" type="alert" @remove="removeAlert"/>
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
					<div></div>
				</div>
			</template>
		</i-modal>

		<i-modal ref="modalConfirmation" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<AlertModal title="Konfirmasi" :message="confirmMessage" type="confirmation" @remove="$refs.modalConfirmation.modalHide()" @confirm="prosesSerial"/>
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
					<div></div>
				</div>
			</template>
		</i-modal>

		<i-modal ref="modalReceiveInput" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<div class="modal-body pt-0 pt-md-3">
					<div class="col-12 pl-0 pr-0 d-flex flex-wrap justify-content-center">
						<div class="col-12 col-md-12 text-center">
							Masukan jumlah barang yang diterima
						</div>
						<div class="col-12 col-md-12 text-center">
							<input type="text" v-model="product_quantity" @focus="alertQty = ''" @keypress="onlyNumber" @paste.prevent class="form-control form-control-sm box-blue rounded-cus font-size-sm-10 font-size-12 text-center">
							<div class="font-size-8 pt-1 color-red text-capitalize">{{alertQty}}</div>
						</div>
					</div>
					<div class="col-12 pl-0 pr-0 mt-3 d-flex justify-content-center justify-content-md-end">
						<button class="col-3 btn btn-outline-danger d-flex justify-content-center rounded-cus" @click="$refs.modalReceiveInput.modalHide()">
							<span class="font-size-11"><i class="fas fa-times"></i></span>
							<div class="font-size-11 pl-2">Batal</div>
						</button>
						<button class="col-3 btn btn-blue d-flex d-flex justify-content-center rounded-cus ml-3" @click="proccessNonSerial">
							<span class="font-size-11"><i class="fas fa-check"></i></span>
							<div class="font-size-11 pl-2">Simpan</div>
						</button>
					</div>
				</div>
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
					<div></div>
				</div>
			</template>
		</i-modal>

    <i-modal ref="modalSerial" class="modal-small">
			<template v-slot:header>
			</template>
			<template v-slot:body>
        <div class="row pl-0 pr-0 mt-3 mt-lg-0">

          <div class="col-12 px-2 p-md-3">
            <div class="justify-content-between rounded-cus cus-box-shadow bg-white list-serial">
              <div v-if="!listSerial">
                <div>Belum Ada List Serial Dipilih</div>
              </div>
              <transition name="slide-fade">
                <div class="col-12 py-3 text-center mb-4 list-serial-box" v-if="!listSerial">
                  <img class="img-fluid" src="/assets/receipt/empty-data.png">
                  <div class="pt-2 font-size-10">Belum ada data yang dapat ditampilkan</div>
                </div>
              </transition>
              <transition name="slide-fade">
                <div class="col-12 font-size-sm-10 mb-1 font-size-12" v-if="listSerial">
                  <div class="mb-3">{{selectedSerialProduct}}Serial <span class="text-uppercase">{{selectedPlatform}}</span> {{ productSerial.sdo_detail_product_name }} ({{ productSerial.serialProduct }})</div>
                </div>
              </transition>
              <transition name="slide-fade">
                <div class="col-12 py-2 mb-4 list-serial-box" v-if="productSerial.serialProduct[selectedPlatform].quantity > 0">
                  <div class="px-3 py-1 mb-2 cus-box-shadow rounded-pill" v-for="(serial, index) in parseInt(productSerial.sdo_stashed_quantity)" :key="index">
                    <div class="d-flex justify-content-between">
                      <input type="text" :value="serialList[index]" readonly class="form-control form-control-sm no-border box-blue rounded-cus font-size-sm-10 font-size-12 mr-3">
                      <div class="pl-3 d-flex align-items-center">
                        <input type="checkbox" @change="(e) => checkSelectedSerial(selectedPlatform, serialList[index], e)" class="form-check-input" :value="serialList[index]" v-model="productSerial.serialProduct[selectedPlatform].serial">
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </div>
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
					<div></div>
				</div>
			</template>
		</i-modal>
	</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import $ from 'jquery';
import helperReceipt from "@/helpers/receipt";
import IModal from '@/components/IModal.vue';
import AlertModal from '@/components/elements/alert/AlertModal.vue';

export default {
	components: {
		AlertModal, IModal
	},
	data() {
		return {
			listSerial: false,
			productSerial: {},
			serialList: [],
			alertMessage: '',
			confirmMessage: '',
			typeProccess: '',
			dataProduct: '',
			product_quantity: '',
			alertQty: '',
			alert: '',
      selectedPlatform: 'pos',
		}
	},
	computed: {
		...mapState('receipt', ['detailReceipt', 'dataSerial', 'serialInvalid', 'sold_platform']),
		...mapState('auth', ['userData']),

    selectedSerialProduct() {
      let arr = [];
      for (const el in this.productSerial.serialProduct) {
        arr = [... arr, ... this.productSerial.serialProduct[el].serial]
      }
      return arr
    }
	},
	methods: {
		...mapActions('receipt', ['getDetailReceipt', 'syncSerial', 'proccessSerial', 'getSerialStashed']),
		...mapMutations('receipt', ['refreshListSerial', 'setSerialInvalid']),
		...mapActions('transactionList', ['scanLinkSerial']),

		async listSerialChange(productSerial, platform) {
      this.selectedPlatform = platform
      this.productSerial = productSerial
			await this.getSerialStashed({
				sdo_id: this.productSerial.sdo_detail_sdo_id,
				product_id: this.productSerial.sdo_detail_product_id,
				product_is_serial: this.productSerial.sdo_detail_product_is_serial,
			})
			var serial = await helperReceipt.getSerialData()
			this.serialList = serial.serial
			/*var sdo = await serial.find(el => el.sdo_id == this.productSerial.sdo_detail_sdo_id)
			if (sdo) {
				var detail = await sdo.detail.find(el => el.serial_type == this.productSerial.sdo_detail_product_is_serial)
				if (detail) {
					this.serialList = await detail.serial_valid
				} else {
					this.serialList = []
				}
			}*/
			$('#inputSerial').focus()
      this.$refs.modalSerial.modalShow()
			this.listSerial = await true
			var ls = $('.list-serial').offset().top;
			ls -= 90;
			$('html').scrollTop(ls);
		},
		removeAlert(){
			this.$refs.modalAlert.modalHide()
			this.alertMessage = ''
		},
		inputNonSerial(data) {
			this.dataProduct = data
			this.$refs.modalReceiveInput.modalShow()
		},
		proccessNonSerial() {
			if (this.product_quantity == '' || this.product_quantity <= 0) {
				this.alertQty = 'Jumlah tidak boleh kosong'
			} else if (this.product_quantity > this.dataProduct.sdo_receive_quantity_unscanned) {
				this.alertQty = 'Tidak boleh melebihi dari jumlah yang di pesan'
			} else {
				this.alertQty = ''
				this.$refs.modalReceiveInput.modalHide()
				this.confirmProses('nonSerial')
			}
		},
		confirmProses(type) {
			this.typeProccess = type
			if (type == 'serial') {
				this.confirmMessage = "Yakin akan memproses pemilihan serial?"
			} else {
				this.confirmMessage = "Yakin akan memproses penerimaan?"
			}
			this.$refs.modalConfirmation.modalShow()
		},
		prosesSerial() {
			let params = {
				sdo_id: this.detailReceipt.sdo_id
			}
			if (this.typeProccess == 'nonSerial') {
				params.product = [{
					product_id: this.dataProduct.sdo_detail_product_id,
					quantity: this.product_quantity
				}]
			}
			this.proccessSerial(params).then(() => {
				this.listSerial = false
				this.$refs.modalConfirmation.modalHide()
				this.getDetailReceipt({
					sdo_code: this.$route.params.slug
				})
			})
		},
    checkSelectedSerial(platform, serial, e) {
      if (this.productSerial.serialProduct[platform].serial.length > this.productSerial.serialProduct[platform].quantity) {
        alert('too much')
        e.target.checked = false
        this.productSerial.serialProduct[platform].serial.pop()
      }

      let serialOther = [];
      for(const prop in this.productSerial.serialProduct) {
        if (prop != platform) {
          serialOther = [... serialOther, ... this.productSerial.serialProduct[prop].serial]
        }
      }

      if(serialOther.includes(serial)) {
        alert('dah ada di platform lain')
        e.target.checked = false
        this.productSerial.serialProduct[platform].serial.pop()
      }

    }
	},
	created() {
		this.$store.dispatch('setPageTitle', 'Penerimaan Barang');
		this.getDetailReceipt({
			sdo_code: this.$route.params.slug
		}).catch( err =>{
			this.alertMessage = err
			this.$refs.modalAlert.modalShow()
		})
	}
};
</script>
